import { CampaignUserType } from "@/typedefs/campaign";
import queryClient from "@/utils/queryClient";
import { campaignsKeys } from "@/utils/queryKeyFactories";
export const removeCampaignsQueries = () => {
    queryClient.removeQueries({ queryKey: campaignsKeys.active(CampaignUserType.Dealer) });
    queryClient.removeQueries({ queryKey: campaignsKeys.active(CampaignUserType.Transporter) });
};
